import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99fe6cf9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container d-flex justify-content-center" }
const _hoisted_2 = { class: "board" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "board" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "board" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "board" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "board" }, null, -1))
const _hoisted_7 = { class: "board" }
const _hoisted_8 = { class: "board" }
const _hoisted_9 = {
  class: "label",
  colspan: "8"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "board" }, null, -1))
const _hoisted_11 = {
  class: "button",
  colspan: "2"
}
const _hoisted_12 = { class: "board" }
const _hoisted_13 = { class: "board" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TitleTag = _resolveComponent("TitleTag")
  const _component_icon = _resolveComponent("icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleTag, { title: "Trackers" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", null, [
        _createElementVNode("tr", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(15, (_) => {
            return _createElementVNode("td", _hoisted_2)
          }), 64))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(5), (_, y) => {
          return (_openBlock(), _createElementBlock("tr", null, [
            _hoisted_3,
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(11), (_, x) => {
              return (_openBlock(), _createElementBlock("td", {
                class: _normalizeClass(["cell", {on: _ctx.display[x + (y * 11)] == 1}])
              }, null, 2))
            }), 256)),
            _hoisted_5,
            _hoisted_6
          ]))
        }), 256)),
        _createElementVNode("tr", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(15, (_) => {
            return _createElementVNode("td", _hoisted_7)
          }), 64))
        ]),
        _createElementVNode("tr", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (_) => {
            return _createElementVNode("td", _hoisted_8)
          }), 64)),
          _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.phrase), 1),
          _hoisted_10,
          _createElementVNode("td", _hoisted_11, [
            _createVNode(_component_router_link, {
              class: "stretched-link",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_icon, {
                  class: "icon",
                  icon: "home"
                })
              ]),
              _: 1
            })
          ]),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (_) => {
            return _createElementVNode("td", _hoisted_12)
          }), 64))
        ]),
        _createElementVNode("tr", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(15, (_) => {
            return _createElementVNode("td", _hoisted_13)
          }), 64))
        ])
      ])
    ])
  ], 64))
}